import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect, Field } from 'formik';
import get from 'lodash/get';

import TouchedFieldError from 'components/touched_field_error';
import FormTooltip, { tooltipPropShape, tooltipDefaultProp } from 'components/form_tooltip';
import FormGroup from './form_group';

const genId = (name, value) => `${name}-${value}`.replace(/\./g, '-');

function handleChange(event, { field, form }, onChangeCallback) {
  const selectedOption = event.currentTarget;
  form.setFieldValue(field.name, selectedOption.value);
  if (onChangeCallback) {
    onChangeCallback({ selectedOption, form });
  }
}

export const FormRadio = ({ checked, label, name, value, className, labelClassName, onChange }) => {
  const radioId = genId(name, value);
  return (
    <div className={className || 'radio'}>
      <label
        className={classNames(labelClassName, { 'no-outline': true, selected: checked })}
        htmlFor={radioId}
      >
        <Field
          name={name}
          render={({ field, form }) => {
            return (
              <input
                type="radio"
                checked={checked}
                className="radio_buttons"
                name={name}
                id={radioId}
                value={value}
                onBlur={field.onBlur}
                onChange={event => handleChange(event, { field, form }, onChange)}
              />
            );
          }}
        />

        <div className="label-text">{label}</div>
      </label>
    </div>
  );
};

FormRadio.defaultProps = {
  className: null,
  onChange: null,
  labelClassName: null,
};

FormRadio.propTypes = {
  checked: PropTypes.bool.isRequired,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  labelClassName: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};

const RadioSelect = ({
  formGroupClassName,
  formGroupIcon,
  formGroupLabel,
  formik,
  name,
  options,
  radioClassName,
  radioLabelClassName,
  radioContainerClassName,
  tooltip,
  onChange,
}) => {
  const fieldValue = get(formik.values, name);
  const { content, header, position } = tooltip;
  return (
    <FormGroup className={formGroupClassName} icon={formGroupIcon} label={formGroupLabel}>
      <div className={radioContainerClassName}>
        <FormTooltip content={content} header={header} position={position}>
          {options.map(({ label, value }) => (
            <FormRadio
              checked={fieldValue === value}
              className={radioClassName}
              key={label}
              label={label}
              labelClassName={radioLabelClassName}
              name={name}
              value={value}
              onChange={onChange}
            />
          ))}
        </FormTooltip>
      </div>
      <TouchedFieldError field={name} />
    </FormGroup>
  );
};

RadioSelect.defaultProps = {
  formGroupClassName: null,
  formGroupIcon: null,
  formik: { values: {} },
  radioClassName: null,
  radioContainerClassName: null,
  radioLabelClassName: null,
  tooltip: tooltipDefaultProp,
  onChange: null,
};

RadioSelect.propTypes = {
  formGroupClassName: PropTypes.string,
  formGroupIcon: PropTypes.string,
  formGroupLabel: PropTypes.node.isRequired,
  formik: PropTypes.shape({ values: PropTypes.object }),
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  radioClassName: PropTypes.string,
  radioContainerClassName: PropTypes.string,
  radioLabelClassName: PropTypes.string,
  tooltip: tooltipPropShape,
  onChange: PropTypes.func,
};

export default connect(RadioSelect);
